import { AxiosResponse } from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';
import { ISagaFunc } from 'services/actionConfigs';
import { IApiGetDemoDataParam, ILoginRequest, ILoginResponse } from '../interfaces/api';
import { IDEMOModelResDataItem } from '../interfaces/demoData';
import { IResponseData } from 'services/response';
import { setPageLoading } from 'widgets/PageLoading';
import storage from 'utils/sessionStorage';
import toast from 'utils/toast';
import { globalNavigateControllerRef } from 'widgets/Navigate';
import actions from './actions';
import apis from './apis';

const getDemoData: ISagaFunc<IApiGetDemoDataParam> = function* () {
  try {
    const resData: AxiosResponse<{ data: IDEMOModelResDataItem[] }> = yield call(apis.getDemoData);
    if (resData?.data?.data) {
      yield put(actions.getDemoData.success(resData.data.data));
    }
  } catch (error) {
    yield put(actions.getDemoData.fail({}));
  } finally {
  }
};

const login: ISagaFunc<ILoginRequest> = function* ({ payload }) {
  setPageLoading(true);
  try {
    const resData: IResponseData<ILoginResponse> = yield call(apis.login, payload);
    if (resData?.data?.data) {
      const { accessToken, refreshToken, user } = resData.data.data;
      
      storage.token.set(accessToken);
      storage.refreshToken.set(refreshToken);
      storage.username.set(`${user.firstName} ${user.lastName}`);
      
      yield put(actions.login.success({ accessToken, refreshToken, user }));
      
      toast.success('Login successful!');
      
      globalNavigateControllerRef.current?.navigate('/');
    }
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || 'Login failed. Please check your credentials.';
    toast.error(errorMessage);
    yield put(actions.login.fail({ message: errorMessage }));
  } finally {
    setPageLoading(false);
  }
};

const logout: ISagaFunc<void> = function* () {
  storage.token.set('');
  storage.refreshToken.set('');
  
  yield put(actions.logout.success({}));
  
  toast.success('Logged out successfully');
  
  globalNavigateControllerRef.current?.navigate('/login');
};

export default function* authServiceSagas() {
  yield takeLatest(actions.getDemoData.fetch, getDemoData);
  yield takeLatest(actions.login.fetch, login);
  yield takeLatest(actions.logout.fetch, logout);
}
